import { render, staticRenderFns } from "./BaseProductColorConfigurations.vue?vue&type=template&id=10e8c552&scoped=true"
import script from "./BaseProductColorConfigurations.vue?vue&type=script&lang=js"
export * from "./BaseProductColorConfigurations.vue?vue&type=script&lang=js"
import style0 from "./BaseProductColorConfigurations.vue?vue&type=style&index=0&id=10e8c552&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e8c552",
  null
  
)

export default component.exports